import React, { useState } from 'react'

export default function TabEmbed({ widgetId, t }) {
  const [copiedLang, setCopiedLang] = useState(null)

  const embedCode = lang =>
    `<div id="kokemuksia-widget" data-id="${widgetId}" data-lang="${lang}"></div>\n<script src="${process.env.WIDGET_URL}"></script>`

  const handleCopy = lang => {
    navigator.clipboard.writeText(embedCode(lang))
      .then(() => { setCopiedLang(lang); setTimeout(() => setCopiedLang(null), 2000) })
  }

  return (
    <React.Fragment>
      <p className="form-hint">{t('widget.embedInstructions') || 'Lisää alla oleva koodi sivustosi HTML-koodiin haluamaasi kohtaan.'}</p>
      {['fi', 'en'].map((lang, i) => (
        <div key={lang} style={i > 0 ? { marginTop: '20px' } : undefined}>
          <p className="form-hint"><strong>{lang.toUpperCase()}</strong></p>
          <div className="widget-embed-code">
            <pre>{embedCode(lang)}</pre>
            <button className="widget-copy-btn" onClick={() => handleCopy(lang)}>
              {copiedLang === lang ? (t('widget.copied') || 'Kopioitu!') : (t('widget.copy') || 'Kopioi')}
            </button>
          </div>
        </div>
      ))}
    </React.Fragment>
  )
}
